import React from "react"
import { Landmark } from "lucide-react"

import { ReactComponent as VisaIcon } from "../../assets/svgs/payment/visa.svg"
import { ReactComponent as MastercardIcon } from "../../assets/svgs/payment/mastercard.svg"
import { ReactComponent as AmexIcon } from "../../assets/svgs/payment/amex.svg"
import { ReactComponent as GooglePayIcon } from "../../assets/svgs/payment/google-pay.svg"
import { ReactComponent as ApplePayIcon } from "../../assets/svgs/payment/apple-pay.svg"

/**
 * Trust rail of accepted payment methods (Visa, Mastercard, Amex, Google Pay,
 * Apple Pay, bank transfer), shown under the "Secure Quote & Book" CTA in the
 * payment section. Card marks are inlined at build time so there are no extra
 * asset requests on the public page.
 */
export default function PaymentMethodsRail() {
	return (
		<div className="pq-payment-methods" aria-label="Accepted payment methods">
			<span className="pq-payment-method" title="Visa">
				<VisaIcon role="img" aria-label="Visa" focusable="false" />
			</span>
			<span className="pq-payment-method" title="Mastercard">
				<MastercardIcon role="img" aria-label="Mastercard" focusable="false" />
			</span>
			<span className="pq-payment-method" title="American Express">
				<AmexIcon role="img" aria-label="American Express" focusable="false" />
			</span>
			<span className="pq-payment-method" title="Google Pay">
				<GooglePayIcon role="img" aria-label="Google Pay" focusable="false" />
			</span>
			<span className="pq-payment-method" title="Apple Pay">
				<ApplePayIcon role="img" aria-label="Apple Pay" focusable="false" />
			</span>
			<span className="pq-payment-method is-bank" title="Bank transfer">
				<Landmark size={13} aria-hidden="true" />
				Bank transfer
			</span>
		</div>
	)
}
